import abi from "./contract/GlobalPool.json";
import { useState, useEffect, Component } from "react";

import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import Buy6 from "./component/buy6";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";
import Slider from "./component/slider"


function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[referlink1,setreflink1]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");

const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[dir1,setdir1]=useState("None");
const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[reward4,setreward4]=useState("None");
const[reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");
const[x5,setx5]=useState("None");
const[x6,setx6]=useState("None");
const[x7,setx7]=useState("None");
const[x8,setx8]=useState("None");
const[x9,setx9]=useState("None");

const[x11,setx11]=useState("None");
const[x12,setx12]=useState("None");
const[x13,setx13]=useState("None");
const[x14,setx14]=useState("None");
const[x15,setx15]=useState("None");

const[a1,seta1]=useState("None");
const[a2,seta2]=useState("None");
const[a3,seta3]=useState("None");
const[a4,seta4]=useState("None");
const[a5,seta5]=useState("None");
const[a6,seta6]=useState("None");
const[a7,seta7]=useState("None");
const[a8,seta8]=useState("None");
const[a9,seta9]=useState("None");
const[a10,seta10]=useState("None");
const[a11,seta11]=useState("None");
const[a12,seta12]=useState("None");
const[a13,seta13]=useState("None");
const[a14,seta14]=useState("None");
const[a15,seta15]=useState("None");
const[a16,seta16]=useState("None");
const[a17,seta17]=useState("None");
const[a18,seta18]=useState("None");
const[a19,seta19]=useState("None");
const[a20,seta20]=useState("None");
const[a21,seta21]=useState("None");
const[a22,seta22]=useState("None");
const[a23,seta23]=useState("None");
const[a24,seta24]=useState("None");
const[a25,seta25]=useState("None");
const[a26,seta26]=useState("None");
const[a27,seta27]=useState("None");
const[a28,seta28]=useState("None");
const[a29,seta29]=useState("None");
const[a30,seta30]=useState("None");
const[a31,seta31]=useState("None");
const[a32,seta32]=useState("None");
const[a33,seta33]=useState("None");
const[a34,seta34]=useState("None");
const[a35,seta35]=useState("None");
const[a36,seta36]=useState("None");
const[a37,seta37]=useState("None");
const[a38,seta38]=useState("None");
const[a39,seta39]=useState("None");
const[a40,seta40]=useState("None");

  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0x5fCd5338fdB6Efc9866E9af86676B96f23Fb3678";
      const contractABI = abi.abi;
    const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
if(myParam == null)
  {
    document.querySelector("#name").value="0x4E3cc26A17099DFBB8032e08770826FaAF92De24";
  }

    const searchParams1 = new URLSearchParams(window.location.search);
    const myParam1 = searchParams1.get('position');
    console.log(myParam1);
    document.querySelector("#position").value=myParam1;
if(myParam1 == null)
  {
    document.querySelector("#possition").value=0;
  } 

  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
      var i = 0;
      const refer = (alltasks[1]);
      setrefer(refer);
     
      const refer2 = (alltasks[23]);
     setrefer2(refer2);
	 const dir1 = Number(alltasks[22]);
     setdir1(dir1);
      const b =Number(alltasks[2]);
     

     document.querySelector("#hid").value  = (alltasks[1]);
     document.querySelector("#direct").value  = (alltasks[2]);
     document.querySelector("#level").value  = (alltasks[4]);
     document.querySelector("#wid").value  = (alltasks[32])/1000000000000000000;
     const direct =Number(alltasks[2]);
     setDirect(direct);
     const level = Number(alltasks[4]);
     setLevel(level);


     const plevel = Number(alltasks[21]);
     setLevelp(plevel);
     
    
     const pack = Number(alltasks[3]) ;

setpackage(pack);

document.querySelector("#pp").value  = Number(alltasks[3]);


document.querySelector("#users").value  = Number(alltasks[13]);




     setB(b);

     

     const dd = Number(alltasks[24]);
          
     setDD(dd);

     const reward1 = Number(alltasks[11])/1000000000000000000;
          
     setreward1(reward1);
     
     const reward2 = Number(alltasks[17])/1000000000000000000;
          
     setreward2(reward2);
     const reward3 = Number(alltasks[18])/1000000000000000000;
          
     setreward3(reward3);
	   
	 	
								
	
      const reward4 =  Number(alltasks[23])/1000000000000000000;
      setreward4(reward4);
      const reward5 =  Number(alltasks[27]);
      setreward5(reward5);




      const reward6 =  Number(alltasks[28]);
      setreward6(reward6);

      const reward7 =  Number(alltasks[29]);
      setreward7(reward7);

     const a1 = Number(alltasks[36])/1000000000000000000;
     seta1(a1);
     const a2 = Number(alltasks[37])/1000000000000000000;
     seta2(a2);
     const a3 = Number(alltasks[38])/1000000000000000000;
     seta3(a3);
     const a4 = Number(alltasks[39])/1000000000000000000;
     seta4(a4);
      const a5 = Number(alltasks[40])/1000000000000000000;
     seta5(a5);
     const a6 = Number(alltasks[41])/1000000000000000000;
     seta6(a6);
     const a7 = Number(alltasks[42])/1000000000000000000;
     seta7(a7);
     const a8 = Number(alltasks[43])/1000000000000000000;
     seta8(a8);
     const a9 = Number(alltasks[44])/1000000000000000000;
     seta9(a9);
     const a10 = Number(alltasks[45])/1000000000000000000;
     seta10(a10);
const a11 = Number(alltasks[46])/1000000000000000000;
     seta11(a11);
     const a12 = Number(alltasks[47])/1000000000000000000;
     seta12(a12);
     const a13 = Number(alltasks[48])/1000000000000000000;
     seta13(a13);
     const a14 = Number(alltasks[49])/1000000000000000000;
     seta14(a14);
const a15 = Number(alltasks[50])/1000000000000000000;
     seta15(a15);
     const a16 = Number(alltasks[51])/1000000000000000000;
     seta16(a16);
     const a17 = Number(alltasks[52])/1000000000000000000;
     seta17(a17);
     const a18 = Number(alltasks[53])/1000000000000000000;
     seta18(a18);
     const a19 = Number(alltasks[54])/1000000000000000000;
     seta19(a19);
     const a20 = Number(alltasks[55])/1000000000000000000;
     seta20(a20);
     const a21 = Number(alltasks[56])/1000000000000000000;
     seta21(a21);
     const a22 = Number(alltasks[57])/1000000000000000000;
     seta22(a22);
     const a23 = Number(alltasks[58])/1000000000000000000;
     seta23(a23);
     const a24 = Number(alltasks[59])/1000000000000000000;
     seta24(a24);
const a25 = Number(alltasks[60])/1000000000000000000;
     seta25(a25);
     const a26 = Number(alltasks[61])/1000000000000000000;
     seta26(a26);
     const a27 = Number(alltasks[62])/1000000000000000000;
     seta27(a27);
     const a28 = Number(alltasks[63])/1000000000000000000;
     seta28(a28);
     const a29 = Number(alltasks[64])/1000000000000000000;
     seta29(a29);
     const a30 = Number(alltasks[65])/1000000000000000000;
     seta30(a30);
     const a31 = Number(alltasks[66])/1000000000000000000;
     seta31(a31);
     const a32 = Number(alltasks[67])/1000000000000000000;
     seta32(a32);
     const a33 = Number(alltasks[68])/1000000000000000000;
     seta33(a33);
     const a34 = Number(alltasks[69])/1000000000000000000;
     seta34(a34);
const a35 = Number(alltasks[70])/1000000000000000000;
     seta35(a35);
     const a36 = Number(alltasks[71])/1000000000000000000;
     seta36(a36);


     const a37 = Number(alltasks[72])/1000000000000000000;
     seta37(a37);
     const a38 = Number(alltasks[73])/1000000000000000000;
     seta38(a38);
     const a39 = Number(alltasks[74])/1000000000000000000;
     seta39(a39);
     const a40 = Number(alltasks[75])/1000000000000000000;
     seta40(a40);



     const x1 = Number(alltasks[18])/1000000000000000000;
     setx1(x1);
     const x2 = Number(alltasks[17])/1000000000000000000;
     setx2(x2);
     const x3 = Number(alltasks[5])/1000000000000000000;
     setx3(x3);
     const x4 = Number(alltasks[6])/1000000000000000000;
     setx4(x4);

          const x5 = Number(alltasks[7])/1000000000000000000;
     setx5(x5);
     const x6 = Number(alltasks[8])/1000000000000000000;
     setx6(x6);
     const x7 = Number(alltasks[9])/1000000000000000000;
     setx7(x7);
     const x8 = Number(alltasks[10])/1000000000000000000;
     setx8(x8);
          const x9 = Number(alltasks[35])/1000000000000000000;
     setx9(x9);



     const x11 = Number(alltasks[33]);
     setx11(x11); 
     const x12 = Number(alltasks[34]);
     setx12(x12);
     const x13 = Number(alltasks[30]);
     setx13(x13);

     const x14 = Number(alltasks[26])/1000000000000000000;
     setx14(x14);


     const x15 = Number(alltasks[11]);
     setx15(x15);
    
 

    if(x15==1)
     {
      const x15 =50;
     setx15(x15);
     }
     if(x15==2)
     {
      const x15 =550;
     setx15(x15);
     }
     if(x15==3)
     {
      const x15 =1550;
     setx15(x15);
     }
     if(x15==4)
     {
      const x15 =3550;
     setx15(x15);
     }


     const dd2 = Number(alltasks[12]);
     setDD2(dd2);

     const dd1 =  Date.now() / 1000;
     setDD1(dd1);


     const tt1 = (dd2 );
   //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);
     
     settt1(tt1);

       
       const b1 = Number(alltasks[5])/1000000000000000000 ;
       setb1(b1);
       const b2 = Number(alltasks[6])/1000000000000000000 ;
       setb2(b2);
       const b3 = Number(alltasks[7])/1000000000000000000 ;
       setb3(b3);
       const b4 = Number(alltasks[8])/1000000000000000000 ;
       setb4(b4);
       const b5 = Number(alltasks[9])/1000000000000000000 ;
       setb5(b5);
       const b6 = Number(alltasks[10])/1000000000000000000 ;
       setb6(b6);

      const b16 = Number(alltasks[21]) ;
       setb16(b16);
       const b7 = Number(alltasks[35])/1000000000000000000 ;
       setb7(b7);

       const b8 = Number(alltasks[27]) ;
       setb8(b8);
       const b9 = Number(alltasks[28]) ;
       setb9(b9);
       const b10 = Number(alltasks[29]) ;
       setb10(b10);
       const b11 = Number(alltasks[30]) ;
       setb11(b11);
     
	   const wlevel = Number(alltasks[25])/1000000000000000000 ;
          
 setLevelw(wlevel);
 const wlevel1 = Number(alltasks[15])/1000000000000000000;
          
 setLevelw1(wlevel1);
 const level1 = Number(alltasks[20]);
          
 setLevel1(level1);
 

    // document.querySelector("#wi1").value = roi2;
     
    // const a1 = Number(alltasks1[0])-1;
          
    // sea1(a1);
    // const a3 = Number(alltasks1[2])/1000000000000000000;
          
   //  sea3(a3);
      
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
     
const pack1 = Number(alltasks[30])/1000000000000000000;
setpackage1(pack1);
     const tt =  Number(alltasks[16])/1000000000000000000;
     settt(tt);
     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);

     
       
if(b16==0)
       {
        const b16 ="Left";
     setb16(b16);
       }
       if(b16==1)
       {
        const b16 ="Right";
     setb16(b16);
       }

       
const tt2 = 1440 - Math.trunc((dd1 - dd2)/60) ;
       
       settt2(tt2);

console.log(pack);
     
 

      
     document.querySelector("#bal").value = tt3;
     const referlink = 'https://bitbank.ltd/?ref='+ account+'&position=0';
     setreflink(referlink);
     document.querySelector("#link").value =referlink;

     const referlink1 = 'https://bitbank.ltd/?ref='+ account+'&position=1';
     setreflink1(referlink1);
     document.querySelector("#link1").value =referlink1;



     const upd = b1+b2+b3+b4+b5+b6+b7+b8+b9+b10+b11+b12+b13+b14+b15;
          
     setupd(upd);

       document.querySelector("#tt2").value = tt2;




        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }

  }, []);
  const [index, setIndex] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setIndex((prev) => (prev + 1) % 4);
  }, 3000);

  return () => clearInterval(interval);
}, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>
    <input type="hidden" id ="direct"></input>
    <input type="hidden" id ="level"></input>
    <input type="hidden" id ="wid"></input>
    <input type="hidden" id ="users"></input>
    
    
 <header class="max-w-4xl mx-auto text-center mb-24 px-4">
      <div
        class="inline-block p-[2px] rounded-2xl bg-gradient-to-tr from-blue-500 to-purple-500 mb-6 shadow-lg shadow-blue-500/20"
      >
        <div class="bg-white rounded-2xl p-4">
          <img src="logo.png" />
        </div>
      </div>
<h1 class="text-6xl font-extrabold tracking-tight mb-4">
  Decentralized
  <span class="text-gradient">Future</span>
</h1>

<p class="text-slate-400 text-white font-light tracking-widest text-sm uppercase">
  BITBANK is a blockchain ecosystem built for transparency, automation, and structured growth.
</p>
      <div class="flex gap-4 justify-center mt-10">
        <button
          class="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full font-bold shadow-lg hover:scale-105 transition-transform"
        >
          Joined On :  {new Date(tt1 * 1000).toLocaleDateString()}
        </button>
        <button
          class="px-8 py-3 bg-white/5 border border-white/10 rounded-full font-bold hover:bg-white/10 transition-colors"
        >
          Rank : Starter
        </button>
      </div>
    </header>

    <section className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-24 px-6">
 
 
 <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition duration-300">
        <div className="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-10 flex items-center justify-center text-center">
          <div>
            <h3 className="text-blue-400 text-3xl md:text-4xl font-extrabold mb-4">
              Register
            </h3>
            
            <p >
              <input style={{
    width: "100%",
    margin: "2px auto",
     display: "block", 
    justifyContent:"center",
    padding: "10px",
    borderRadius: "6px",
    border: "none",
    color:"black",
    outline: "none"
  }}  type="text" id ="amt"  ></input>
            </p>
            <br></br>
            <p className="text-white-400 text-xl font-semibold">
             <Buy state={state}/>
             
            </p>
          </div>
        </div>

      </div>

      {/* Card 2 */}
      <div className="relative p-[1.6px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition duration-300">
        <div className="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-10 flex items-center justify-center text-center">
          <div>
            <h3 className="text-purple-400 text-3xl md:text-4xl font-extrabold mb-4">
              Withdraw
            </h3>
            <p >
             <input  type="text" id ="test" style={{
    width: "100%",
    maxWidth: "300px",
    margin: "2px auto",
    display: "block", 
    padding: "10px",
    borderRadius: "6px",
    border: "none",
    outline: "none",
    color: "#000000", 
    backgroundColor: "#ffffff"
  }}></input>
            </p>
            <br></br>
             <p className="text-white-400 text-xl font-semibold">
             <Buy3 state={state}  />
            </p>

          </div>
        </div>
      </div>

    
      {/* Card 4 */}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-blue-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Withdraw
              </p>
              
            </div>
          </div>

          <div className="space-y-4">
             <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>

            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Withdrawal </span>
              <span className="text-blue-400 text-xs">{wlevel1} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold"> Withdrawal Pending</span>
              <span className="text-blue-400 text-xs">{tt -wlevel1} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold"> Last Withdraw</span>
              <span className="text-blue-400 text-xs">{a37} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold"> 2nd Last Withdraw</span>
              <span className="text-blue-400 text-xs">{a38} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold"> 3rd Last Withdraw</span>
              <span className="text-blue-400 text-xs">{a39} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold"> 4th Last Withdraw</span>
              <span className="text-blue-400 text-xs">{a40} USDT</span>
            </div>
          </div>
        </div>
      </div>

      {/* Card 5 */}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-purple-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Deposit
              </p>
             
            </div>
          </div>

          <div className="space-y-4">
           
                     <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Deposit</span>
              <span className="text-purple-400 text-xs">{pack} USDT</span>
            </div>
          </div>
        </div>
      </div>

      {/* Card 6*/}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-pink-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Income
              </p>
              <h3 className="text-white text-lg font-bold"></h3>
            </div>
          </div>

          <div className="space-y-4">
              <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>

            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Income</span>
              <span className="text-pink-400 text-xs">{tt} USDT</span>
            </div>
            
            
          </div>
        </div>
      </div>

    

      {/* Card 5 */}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-purple-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Team
              </p>
             
            </div>
          </div>

          <div className="space-y-4">
               <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
           

            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Direct Team</span>
              <span className="text-purple-400 text-xs"> {direct}</span>
            </div>
          </div>
        </div>
      </div>


        {/* Card -6*/}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-pink-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Matching Income
              </p>
              <h3 className="text-white text-lg font-bold"></h3>
            </div>
          </div>

          <div className="space-y-4">
              <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
              <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Income</span>
              <span className="text-pink-400 text-xs">{x1} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Current Week Income</span>
              <span className="text-pink-400 text-xs">{a1} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Last Week Income</span>
              <span className="text-pink-400 text-xs">{a2} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">2 Week Ago Income</span>
              <span className="text-pink-400 text-xs">{a3} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">3 Week Ago Income</span>
              <span className="text-pink-400 text-xs">{a4} USDT</span>
            </div>
          </div>
        </div>
      </div>

      {/* Card -7*/}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-cyan-400 text-[1.6rem] font-bold uppercase tracking-widest">
               Staking Bonus
              </p>
              
            </div>
          </div>

          <div className="space-y-4">
               <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Income</span>
              <span className="text-cyan-400 text-xs">{x2} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Current Month Income</span>
              <span className="text-cyan-400 text-xs">{a33} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Last Month Income</span>
              <span className="text-cyan-400 text-xs">{a34} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">2 Month Ago Income</span>
              <span className="text-cyan-400 text-xs">{a35} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">3 Month Ago Income</span>
              <span className="text-cyan-400 text-xs">{a36} USDT</span>
            </div>
           
          </div>
        </div>
      </div>


  {/* Card 5 */}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-purple-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Achiever's Club
              </p>
             
            </div>
          </div>

          <div className="space-y-4">
               <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
           

            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Income</span>
              <span className="text-purple-400 text-xs">{x3} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Current Month Income</span>
              <span className="text-purple-400 text-xs">{a5} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Last Month Income</span>
              <span className="text-purple-400 text-xs">{a6} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">2 Month Ago Income</span>
              <span className="text-purple-400 text-xs">{a7} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">3 Month Ago Income</span>
              <span className="text-purple-400 text-xs">{a8} USDT</span>
            </div>
          </div>
        </div>
      </div>     
       
         {/* Card -6*/}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-pink-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Star Business Matching
              </p>
              <h3 className="text-white text-lg font-bold"></h3>
            </div>
          </div>

          <div className="space-y-4">
              <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Income</span>
              <span className="text-pink-400 text-xs">{x4} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Current Month Income</span>
              <span className="text-pink-400 text-xs">{a9} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Last Month Income</span>
              <span className="text-pink-400 text-xs">{a10} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">2 Month Ago Income</span>
              <span className="text-pink-400 text-xs">{a11} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">3 Month Ago Income</span>
              <span className="text-pink-400 text-xs">{a12} USDT</span>
            </div>
          </div>
        </div>
      </div>

      {/* Card -7*/}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-cyan-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Silver Level Matching
              </p>
              
            </div>
          </div>

          <div className="space-y-4">
               <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
              <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Income</span>
              <span className="text-cyan-400 text-xs">{x5} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Current Month Income</span>
              <span className="text-cyan-400 text-xs">{a13} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Last Month Income</span>
              <span className="text-cyan-400 text-xs">{a14} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">2 Month Ago Income</span>
              <span className="text-cyan-400 text-xs">{a15} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">3 Month Ago Income</span>
              <span className="text-cyan-400 text-xs">{a16} USDT</span>
            </div>
           
          </div>
        </div>
      </div>

      {/* Card -8*/}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-blue-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Pearl Business Matching
              </p>
              
            </div>
          </div>

          <div className="space-y-4">
               <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
            
  <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Income</span>
              <span className="text-blue-400 text-xs">{x6} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Current Month Income</span>
              <span className="text-blue-400 text-xs">{a17} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Last Month Income</span>
              <span className="text-blue-400 text-xs">{a18} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">2 Month Ago Income</span>
              <span className="text-blue-400 text-xs">{a19} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">3 Month Ago Income</span>
              <span className="text-blue-400 text-xs">{a20} USDT</span>
            </div>
          </div>
        </div>
      </div>

      {/* Card -9 */}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-purple-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Gold Business Matching
              </p>
             
            </div>
          </div>

          <div className="space-y-4">
               <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
           
              <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Income</span>
              <span className="text-purple-400 text-xs">{x7} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Current Month Income</span>
              <span className="text-purple-400 text-xs">{a21} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Last Month Income</span>
              <span className="text-purple-400 text-xs">{a22} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">2 Month Ago Income</span>
              <span className="text-purple-400 text-xs">{a23} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">3 Month Ago Income</span>
              <span className="text-purple-400 text-xs">{a24} USDT</span>
            </div>
         
          </div>
        </div>
      </div>
     


         {/* Card -6*/}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-pink-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Royal Diamond Business Matching
              </p>
              <h3 className="text-white text-lg font-bold"></h3>
            </div>
          </div>

          <div className="space-y-4">
              <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Income</span>
              <span className="text-pink-400 text-xs">{x8} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Current Month Income</span>
              <span className="text-pink-400 text-xs">{a25} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Last Month Income</span>
              <span className="text-pink-400 text-xs">{a26} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">2 Month Ago Income</span>
              <span className="text-pink-400 text-xs">{a27} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">3 Month Ago Income</span>
              <span className="text-pink-400 text-xs">{a28} USDT</span>
            </div>
          </div>
        </div>
      </div>

      {/* Card -7*/}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-cyan-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Diamond Business Matching
              </p>
              
            </div>
          </div>

          <div className="space-y-4">
               <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
              <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Total Income</span>
              <span className="text-cyan-400 text-xs">{x9} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Current Month Income</span>
              <span className="text-cyan-400 text-xs">{a29} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Last Month Income</span>
              <span className="text-cyan-400 text-xs">{a30} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">2 Month Ago Income</span>
              <span className="text-cyan-400 text-xs">{a31} USDT</span>
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">3 Month Ago Income</span>
              <span className="text-cyan-400 text-xs">{a32} USDT</span>
            </div>
           
          </div>
        </div>
      </div>

      {/* Card 6*/}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-pink-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Business Matching
              </p>
              <h3 className="text-white text-lg font-bold"></h3>
            </div>
          </div>

          <div className="space-y-4">
               <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
           

            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Left Leg</span>
              <span className="text-pink-400 text-xs">{b8} USDT</span>
            </div>
              <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Right Leg</span>
              <span className="text-pink-400 text-xs">{b9} USDT</span>
            </div>
            
          </div>
        </div>
      </div>

      {/* Card 7*/}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-cyan-500/50 to-transparent shadow-[0_0_25px_rgba(6,182,212,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#081b25]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-[0_0_15px_rgba(6,182,212,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-cyan-400 text-[1.6rem] font-bold uppercase tracking-widest">
                C/F Matching Business
              </p>
              
            </div>
          </div>

          <div className="space-y-4">
               <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>
            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Left Leg C/F </span>
              <span className="text-cyan-400 text-xs">{b8-level} USDT</span>
            </div>

            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Right Leg C/F </span>
              <span className="text-cyan-400 text-xs">{b9-level} USDT</span>
            </div>
          </div>
        </div>
      </div>
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-blue-500/50 to-transparent shadow-[0_0_25px_rgba(59,130,246,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#0f172a]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-blue-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Direct
              </p>
              
            </div>
          </div>

          <div className="space-y-4">
               <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>

            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Left Direct</span>
              <span className="text-blue-400 text-xs">{x11} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Right Direct</span>
              <span className="text-blue-400 text-xs">{x12} USDT</span>
            </div>
          </div>
        </div>
      </div>

      {/* Card 5 */}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-purple-500/50 to-transparent shadow-[0_0_25px_rgba(168,85,247,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#120b1e]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-[0_0_15px_rgba(168,85,247,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-purple-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Referlink
              </p>
             
            </div>
          </div>

          <div className="space-y-4">
              <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>

            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Referlink Left</span>
              <span className="text-purple-400 text-xs">{referlink}
      <button
        style={{ marginLeft: "8px", border: "none", background: "transparent", cursor: "pointer" }}
        onClick={() => navigator.clipboard.writeText(referlink)}
      >
        <img src="copy.png" width="15px" alt="copy" />
      </button></span>
            </div>
              <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Referlink Right</span>
              <span className="text-purple-400 text-xs"> {referlink1}
      <button
        style={{ marginLeft: "8px", border: "none", background: "transparent", cursor: "pointer" }}
        onClick={() => navigator.clipboard.writeText(referlink1)}
      >
        <img src="copy.png" width="15px" alt="copy" />
      </button></span>
            </div>
              <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">My Refer </span>
              <span className="text-purple-400 text-xs">{refer}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Card 6*/}
      <div className="relative p-[1px] rounded-[32px] bg-gradient-to-b from-pink-500/50 to-transparent shadow-[0_0_25px_rgba(236,72,153,0.2)] hover:scale-105 transition-transform duration-300">
        <div className="bg-[#1a1025]/90 backdrop-blur-xl rounded-[31px] p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-[0_0_15px_rgba(236,72,153,0.5)]">
              <span className="text-white font-bold"></span>
            </div>
            <div>
              <p className="text-pink-400 text-[1.6rem] font-bold uppercase tracking-widest">
                Left/Right
              </p>
            </div>
              <h3 className="text-white text-lg font-bold"></h3>
          </div>

          <div className="space-y-4">
              <div
              class="flex justify-between items-center border-b border-white/5 pb-2"
            >
             
            </div>

            <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Left Leg </span>
              <span className="text-pink-400 text-xs">{b8} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Right Leg</span>
              <span className="text-pink-400 text-xs">{b9} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Left Leg C/F</span>
              <span className="text-pink-400 text-xs">{b8-level} USDT</span>
            </div>
             <div className="flex justify-between items-center pt-1">
              <span className="text-slate-200 font-bold">Right Leg C/F</span>
              <span className="text-pink-400 text-xs">{b9-level} USDT</span>
            </div>
          </div>
        </div>
      </div>

      

    </section>
  
    
     
    
    <br></br>

   </div>

  );
}

export default App;